import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { FAQS } from '../../data/ribbonData';

export const RibbonFAQ = () => (
  <section className="py-20 sm:py-28" data-testid="ribbon-faq">
    <div className="max-w-3xl mx-auto px-5 sm:px-8">
      <p className="rb-eyebrow mb-4">FAQ</p>
      <h2 className="rb-head text-5xl sm:text-6xl mb-10"><span className="rb-neon">Questions,</span> <span className="rb-grad">answered.</span></h2>
      <Accordion type="single" collapsible className="w-full space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} className="rb-glass rounded-2xl px-6 border-b-0">
            <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-white hover:no-underline hover:text-[#ff9a3c]" data-testid={`faq-trigger-${i}`}>
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-white/70 text-base leading-relaxed" data-testid={`faq-answer-${i}`}>{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
